import type { Column, Table } from "@tanstack/react-table";

/**
 * 全リーフ列を、ユーザーが設定した表示順（columnOrder）で返す。
 *
 * TanStack Table が columnOrder を反映するのは `getHeaderGroups()` だけで、
 * `getAllLeafColumns()` / `getVisibleLeafColumns()` は列定義の順序のまま返す。
 * ヘッダには非表示列が含まれないため、表示/非表示を切り替える設定ダイアログの
 * ように「非表示列も含めて表示順に並べたい」場面ではこちらを使う。
 */
export function orderedLeafColumns<T>(table: Table<T>): Column<T, unknown>[] {
  const all = table.getAllLeafColumns();
  const order = table.getState().columnOrder;
  if (order.length === 0) return all;

  const byId = new Map(all.map((column) => [column.id, column]));
  const ordered = order
    .map((id) => byId.get(id))
    .filter((column): column is Column<T, unknown> => column !== undefined);
  // columnOrder に載っていない列（あとから追加された列）は末尾に回す。
  const rest = all.filter((column) => !order.includes(column.id));
  return [...ordered, ...rest];
}
